import React from "react";
interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  darkmode?: string;
  dark?(): any;
}
export default function Image({ ...props }: ImageProps) {
  return <img {...props} alt="logo" />;
}
